import PincodeInputComponent from './PincodeInputComponent.vue';

export default PincodeInputComponent;